"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>();
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLParagraphElement>();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: statsRef,
    isVisible: statsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const stats = [{
    label: "THREAT DETECTION ACTIVE 24/7"
  }, {
    label: "AI-DRIVEN RISK MITIGATION"
  }, {
    label: "SCALABLE ENTERPRISE SECURITY"
  }];
  return <section data-section-id="4778" id="ready-to-protect" className="bg-background text-foreground relative overflow-hidden py-32 md:py-48 lg:py-[200px] px-6 md:px-12">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="w-[900px] h-[900px] max-w-[120%] rounded-lg blur-3xl opacity-15" style={{
        background: "radial-gradient(circle, var(--primary) 0%, transparent 70%)"
      }} />
      </div>

      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div className="relative max-w-7xl mx-auto">
        {}
        <div className="flex items-center gap-4 md:gap-6 mb-20 md:mb-28">
          <span className="font-mono text-[10px] md:text-xs uppercase tracking-widest text-muted-foreground whitespace-nowrap">
            § 0X / SECURE
          </span>
          <div className="flex-1 h-px bg-border" />
          <span className="font-mono text-[10px] md:text-xs uppercase tracking-widest text-muted-foreground whitespace-nowrap">
            INTELLIGENCE
          </span>
        </div>

        {}
        <div className="flex flex-col items-center text-center">
          <h2 ref={headingRef} className="font-default font-light leading-[0.95] tracking-tight text-foreground transition-all duration-1000 ease-out" style={{
          fontSize: "clamp(3rem, 10vw, 8.75rem)",
          opacity: headingVisible ? 1 : 0,
          transform: headingVisible ? "translateY(0)" : "translateY(40px)"
        }}>
            <span className="block">Secure your</span>
            <span className="block italic font-normal">digital future.</span>
          </h2>

          <p ref={paragraphRef} className="mt-10 md:mt-14 max-w-[55ch] text-base md:text-lg leading-relaxed text-foreground/85 font-default transition-all duration-1000 delay-150 ease-out" style={{
          opacity: paragraphVisible ? 1 : 0,
          transform: paragraphVisible ? "translateY(0)" : "translateY(30px)"
        }}>
            Whether you're a growing startup or an established enterprise, InfinitySecure provides the AI-powered shield your business needs. Let's discuss your security posture and build a resilient defense.
          </p>

          <div ref={ctaRef} className="mt-12 md:mt-16 flex flex-col sm:flex-row items-center justify-center gap-5 transition-all duration-1000 delay-300 ease-out" style={{
          opacity: ctaVisible ? 1 : 0,
          transform: ctaVisible ? "translateY(0)" : "translateY(20px)"
        }}>
            {}
            <div className="relative group">
              <div aria-hidden="true" className="absolute inset-0 rounded-lg blur-xl opacity-60 group-hover:opacity-90 transition-opacity duration-500" style={{
              background: "var(--primary)",
              animation: "ember-pulse 3s ease-in-out infinite"
            }} />
              <Link to="/ContactPage" className="relative">
                <Button size="lg" className="relative bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-8 text-sm font-mono uppercase tracking-widest rounded-lg shadow-lg">
                  Request Assessment
                  <ArrowUpRight className="ml-1 size-4" />
                </Button>
              </Link>
            </div>

            {}
            <Link to="/ContactPage">
              <Button variant="outline" size="lg" className="h-14 px-8 text-sm font-mono uppercase tracking-widest rounded-lg border-border bg-transparent text-foreground hover:bg-accent hover:text-accent-foreground">
                Contact Our Team
              </Button>
            </Link>
          </div>
        </div>

        {}
        <div ref={statsRef} className="mt-24 md:mt-32 transition-all duration-1000 delay-500 ease-out" style={{
        opacity: statsVisible ? 1 : 0,
        transform: statsVisible ? "translateY(0)" : "translateY(20px)"
      }}>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-0">
            {stats.map((stat, i) => <div data-index={i} key={i} className="flex items-center gap-4 md:gap-6">
                {i > 0 && <span aria-hidden="true" className="hidden md:inline-block w-8 h-px bg-border" />}
                <span className="font-mono text-[10px] md:text-xs uppercase tracking-widest text-muted-foreground whitespace-nowrap">
                  {stat.label}
                </span>
              </div>)}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes ember-pulse {
          0%, 100% {
            opacity: 0.5;
            transform: scale(1);
          }
          50% {
            opacity: 0.85;
            transform: scale(1.08);
          }
        }
      `}</style>
    </section>;
}